// extracted by mini-css-extract-plugin
export default {"TitleName":"Header_TitleName__bo5LA","Container":"Header_Container__SpaxP","LinkName":"Header_LinkName__JjA-2"};